export default __webpack_public_path__ + "static/ai-solutions-with-roadmap2--mobile-ac9cd0d0a421f6d26dbf5bc3cad2c7c6.webp";